import { render, staticRenderFns } from "./SectionOpening.vue?vue&type=template&id=388ffd9c&scoped=true&"
import script from "./SectionOpening.vue?vue&type=script&lang=js&"
export * from "./SectionOpening.vue?vue&type=script&lang=js&"
import style0 from "./SectionOpening.vue?vue&type=style&index=0&id=388ffd9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388ffd9c",
  null
  
)

export default component.exports